// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\PersonResponse

export type PersonApiResponse = {
	id: string;
	firstName: string;
	lastName: string;
	email: string;
	phone: string;
};

export type Person = {
	id: string;
	firstName: string;
	lastName: string;
	email: string;
	phone: string;
};

export function hydratePerson(data: PersonApiResponse): Person {
	return { ...data };
}